import React, { isValidElement } from 'react';
import 'twin.macro';
import { CustomFieldTitle } from './CustomFieldTitle';

import { Color } from 'types/colors';
import { Tag } from 'components/Tag';
import { TagColorWithIntensity } from '@teetsh/app/src/styles/userConstants';

interface Item {
  id: string;
  value: string;
  color?: Color | TagColorWithIntensity;
}

interface Props {
  items: Item[];
  pluralTitle: string;
  title: string;
}

export function Items(props: Props) {
  const { items, pluralTitle, title } = props;
  if (items.length === 0) {
    return null;
  }
  return (
    <div>
      {items.length > 0 && (
        <CustomFieldTitle
          tw="mr-1"
          title={items.length > 1 ? pluralTitle : title}
        />
      )}
      {items.length === 1 ? (
        <>
          <wbr />
          {items[0]?.color ? (
            <Tag color={items[0].color}>{items[0].value}</Tag>
          ) : (
            <span tw="break-words ml-1">
              {/* Va savoir pourquoi mais en passant sur React 18 si je check pas bien ce que je print ça peut me péter à la tronche... */}
              {isValidElement(items[0].value) ||
              typeof items[0].value === 'string'
                ? items[0].value
                : null}
            </span>
          )}
        </>
      ) : null}
      {items.length > 1 ? (
        <>
          {items.map(item =>
            item?.color ? (
              <Tag tw="mx-0.5" color={item.color} key={item.id}>
                {item.value}
              </Tag>
            ) : (
              <div tw="pl-3 break-words" key={item.id}>
                {item.value}
              </div>
            ),
          )}
        </>
      ) : null}
    </div>
  );
}
